function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "title", "width", "height", "children", "disableMargins"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'classnames';
import "./creditCardIcons.css";
var CreditCardIconWrapper = function CreditCardIconWrapper(_ref) {
  var id = _ref.id,
    className = _ref.className,
    title = _ref.title,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '20' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '20' : _ref$height,
    children = _ref.children,
    disableMargins = _ref.disableMargins,
    nativeProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    id: id,
    className: classNames('lm-IconCreditCard', "lm-IconCreditCard--".concat(title), _defineProperty({}, "lm-IconCreditCard--disable-margin-".concat(disableMargins), disableMargins), className)
  }, nativeProps), /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "0px",
    height: "0px",
    viewBox: "0 0 ".concat(width, " ").concat(height),
    style: {
      paddingBottom: "".concat(100 * (Number(height) / Number(width)), "%")
    },
    preserveAspectRatio: "xMidYMin slice",
    role: "img",
    "aria-label": title
  }, children, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("title", null, title))));
};
CreditCardIconWrapper.propTypes = {
  /** Add an optional ID to this element: `<span class="lm-IconCreditCard">`. If a label is provided, this ID will appear on the wrapper. */id: _pt.string,
  /** Add custom classes to this element: `<span class="lm-IconCreditCard">`. */className: _pt.string,
  /** Similar to the "alt" attribute on image tags, this is optional for custom tooltips and will default to the icon
     * name if not overriden. */
  title: _pt.string,
  /** Disable the top, bottom, right or all three margins for spacing purposes. */disableMargins: _pt.oneOf(['all', 'top', 'bottom', 'right']),
  /** @private */width: _pt.string,
  /** @private */height: _pt.string
};
export default CreditCardIconWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/_esm/CreditCardIconWrapper.js
// module id = 406
// module chunks = 0